module.exports = __webpack_public_path__ + "img/special.409c135a.png";